import { strategyToOptions } from '@/common/utils/strategyToOptions'
import { HomologatedIntegrationStatus } from '@/features/modelIntegrationCodes/types/modelIntegrationCode.type'

export const homologatedStatusLabels: Record<HomologatedIntegrationStatus, string> = {
  with_link: 'Concluído',
  link_in_progress: 'Em progresso',
  failed_on_linking: 'Falha',
}

export const homologatedStatusOptions = strategyToOptions(homologatedStatusLabels)
